import type { ReactNode } from 'react'
import { NoAccessPage } from '@/pages/no-access'
import { useActingMode, type AccessPair } from '@/shared/lib'

/**
 * Гард маршрута: режим `none` — «Нет доступа» на том же адресе внутри каркаса, без
 * перенаправлений (`docs/roles/03-frontend-architecture.md` §6). Страница в режиме
 * `needs-client` открывается и сама предлагает выбрать клиента.
 */
export function RouteGuard({ access, children }: { access: AccessPair; children: ReactNode }) {
  const { mode } = useActingMode(access)
  return mode === 'none' ? <NoAccessPage /> : children
}
